export default __webpack_public_path__ + "static/media/me.b060124f.png";